import { Box, Flex, Icon, Image, Link, Text } from "@chakra-ui/react";
import {
  AULAS,
  CRONOGRAMA,
  EXTRA,
  MENULIST,
  PLAY,
  QUESTION,
} from "../../assets";
import { RiPlayFill } from "react-icons/ri";

const linksList = [
  {
    icon: PLAY,
    link: "/home",
    title: "Cadastrar aulas gravadas",
  },
  {
    icon: CRONOGRAMA,
    link: "/home",
    title: "Cadastrar Cronograma de aulas",
  },
  {
    icon: QUESTION,
    link: "/registrar-questoes",
    title: "Cadastrar Questões",
  },
  {
    icon: MENULIST,
    link: "/simulador/criar",
    title: "Criar Simulado",
  },
  {
    icon: QUESTION,
    link: "/home",
    title: "Criar lista de tarefas",
  },
  {
    icon: AULAS,
    link: "/home",
    title: "Cadastrar aulas gravadas",
  },
  {
    icon: EXTRA,
    link: "/home",
    title: "Conteúdo Extra",
  },
];

export function Home() {
  return (
    <Flex w="100%" flexDirection="column">
      <Flex style={{ marginTop: 48, alignItems: "center" }}>
        <Box
          style={{
            width: 30,
            height: 4,
            backgroundColor: "#0577BE",
            borderRadius: 10,
          }}
        />
        <Text
          style={{
            color: "#343434",
            fontSize: 24,
            fontWeight: 600,
            fontFamily: "Kanit",
            marginLeft: 13,
          }}
        >
          Painel de controle
        </Text>
      </Flex>

      <Flex style={{ marginTop: 50, gap: 35, flexWrap: "wrap" }}>
        {linksList.map((item, index) => {
          return (
            <Flex
              key={index}
              style={{
                width: "247.88px",
                height: "142px",
                borderRadius: 10,
                borderWidth: 2,
                borderColor: "#0577BE",
                flexDirection: "column",
                padding: 20,
                justifyContent: "space-between",
              }}
              bgGradient="linear(#0577BE 0%, #2992D3 25%, #2992D3 50%)"
            >
              <Flex
                style={{
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    color: "#F5F5F5",
                    fontSize: 18,
                    fontFamily: "Kanit",
                    fontWeight: 600,
                    width: 137,
                    lineHeight: 1,
                  }}
                >
                  {item.title}
                </Text>

                <Image
                  src={item.icon}
                  alt="logo"
                  style={{ width: "25.88", height: "20px" }}
                />
              </Flex>

              <Flex>
                <Link href={item.link}>
                  <Flex
                    style={{
                      width: "86px",
                      height: "27px",
                      backgroundColor: "#F5F5F5",
                      borderRadius: 13,
                      alignItems: "center",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: "#0577BE",
                        fontSize: 14,
                        fontFamily: "Kanit",
                        fontWeight: 500,
                        marginRight: 5,
                      }}
                    >
                      Iniciar
                    </Text>
                    <Icon fontSize="14px" as={RiPlayFill} color="#0577BE" />
                  </Flex>
                </Link>
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
}
